import { ClickableDiv } from '@wwe-portal/ui/components/button';
import Link from 'next/link';

export const BackToHome = () => {
  return (
    <Link href="/">
      <ClickableDiv className="bg-blue700 flex items-center justify-center gap-3 overflow-hidden rounded-md px-5 py-[14px] font-semibold text-white">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12ZM12 11L16 11L16 13L12 13L12 16L8 12L12 8L12 11Z"
            fill="white"
          ></path>
        </svg>
        BACK TO HOME
      </ClickableDiv>
    </Link>
  );
};
